




































import {Component, Prop, Vue} from 'vue-property-decorator';
import Cell from "@/app/minesweeper/Cell";

@Component
export default class CellSquare extends Vue {
    @Prop() public cell!: Cell;

    readonly CELL_SIZE_PX = 30;
    readonly CELL_CLICK_THRESHOLD_MILLISECONDS = 200;
    private lastMouseDownTimestamp!: number;

    get cellStyle(): any {
        const style = {
            left: (this.cell.x * this.CELL_SIZE_PX) + 'px',
            top: (this.cell.y * this.CELL_SIZE_PX) + 'px',
            height: this.CELL_SIZE_PX + 'px',
            width: this.CELL_SIZE_PX + 'px',
        } as any;

        if (this.cell.isOpened() && !this.cell.isExploded()) {
            style['background-color'] = this.cell.openedBy.color;
        }

        return style;
    }

    cellWithNumberStyle(cell: Cell): any {
        const colors = [
            '#0a0a0a',
            '#0000ff',
            '#007b00',
            '#ff0000',
            '#00007b',
            '#7b0000',
            '#007b7b',
            '#000000',
            '#7b7b7b'
        ];

        return {
            color: colors[cell.neighbourMinesCount],
        };
    }

    onMouseDown(): void {
        this.lastMouseDownTimestamp = (new Date()).getTime();
    }

    onMouseUp($event: MouseEvent): void {
        if ($event.button === 2) {
            return;
        }

        const currentTimestamp = (new Date()).getTime();
        if (currentTimestamp - this.lastMouseDownTimestamp < this.CELL_CLICK_THRESHOLD_MILLISECONDS) {
            this.$emit('open-cell', this.cell);
        }
    }

    onRightClick(): void {
        const currentTimestamp = (new Date()).getTime();
        if (currentTimestamp - this.lastMouseDownTimestamp < this.CELL_CLICK_THRESHOLD_MILLISECONDS) {
            this.$emit('flag-cell', this.cell);
        }
    }
}
